import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import PageTitle from "../ui/PageTitle";
import ToastMsg from "../ui/ToastMsg";
import useApp from "../../utils/useApp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBed,
  faBoxesStacked,
  faBriefcase,
  faBuilding,
  faBullseye,
  faClipboardQuestion,
  faFileText,
  faHouseChimney,
  faUserFriends,
} from "@fortawesome/free-solid-svg-icons";
import OrgGoalTemplates from "./goaltemplates/OrgGoalTemplates";
import OrgDetails from "./details/OrgDetails";
import useMenuToggle from "../../utils/useMenuToggle";
import OrgHousehold from "./householdconfig/OrgHousehold";
import OrgCustomAssessments from "./assessments/OrgCustomAssessments";
import OrgBedManagement from "./beds/OrgBedManagement";
import OrgDwellingManagement from "./beds/OrgDwellingManagement";
import OrgFacilityManagement from "./beds/OrgFacilityManagement";
import OrgCustomNoteTypes from "./notes/OrgCustomNoteTypes";
import OrgResources from "./resources/OrgResources";

const Settings = () => {
  const { showMenu, auth }: any = useApp();
  const toggleMenu = useMenuToggle();
  const [activeDetails, setActiveDetails] = useState<boolean>(false);
  const [activeHousehold, setActiveHousehold] = useState<boolean>(false);
  const [activeNotes, setActiveNotes] = useState<boolean>(false);
  const [activeGoals, setActiveGoals] = useState<boolean>(false);
  const [activeAssessTypes, setActiveAssessTypes] = useState<boolean>(false);
  const [activeResources, setActiveResources] = useState<boolean>(false);
  const [activeDwellings, setActiveDwellings] = useState<boolean>(false);
  const [activeFacilities, setActiveFacilities] = useState<boolean>(false);
  const [activeBedManage, setActiveBedManage] = useState<boolean>(false);
  const [facilityUpdated, setFacilityUpdated] = useState<boolean>(false);
  const [roomsUpdated, setRoomsUpdated] = useState<boolean>(false);
  const [orgToSave, setOrgToSave] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");
  const searchRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setActiveDetails(true);
    setActiveHousehold(false);
    setActiveNotes(false);
    setActiveGoals(false);
    setActiveAssessTypes(false);
    setActiveResources(false);
    setActiveDwellings(false);
    setActiveFacilities(false);
    setActiveBedManage(false);
  }, []);

  const onNavClick = (route: string) => {
    switch (route) {
      case "details":
        setActiveDetails(true);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveResources(false);
        setActiveDwellings(false);
        setActiveFacilities(false);
        setActiveBedManage(false);
        break;
      case "household":
        setActiveDetails(false);
        setActiveHousehold(true);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveResources(false);
        setActiveDwellings(false);
        setActiveFacilities(false);
        setActiveBedManage(false);
        break;
      case "notes":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(true);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveResources(false);
        setActiveDwellings(false);
        setActiveFacilities(false);
        setActiveBedManage(false);
        break;
      case "goals":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(true);
        setActiveAssessTypes(false);
        setActiveResources(false);
        setActiveDwellings(false);
        setActiveFacilities(false);
        setActiveBedManage(false);
        break;
      case "assessments":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(true);
        setActiveResources(false);
        setActiveDwellings(false);
        setActiveFacilities(false);
        setActiveBedManage(false);
        break;
      case "resources":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveResources(true);
        setActiveDwellings(false);
        setActiveFacilities(false);
        setActiveBedManage(false);
        break;
      case "dwellings":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveResources(false);
        setActiveDwellings(true);
        setActiveFacilities(false);
        setActiveBedManage(false);
        break;
      case "facilities":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveResources(false);
        setActiveDwellings(false);
        setActiveFacilities(true);
        setActiveBedManage(false);
        break;
      case "rooms":
        setActiveDetails(false);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveResources(false);
        setActiveDwellings(false);
        setActiveFacilities(false);
        setActiveBedManage(true);
        break;
      default:
        setActiveDetails(true);
        setActiveHousehold(false);
        setActiveNotes(false);
        setActiveGoals(false);
        setActiveAssessTypes(false);
        setActiveResources(false);
        setActiveDwellings(false);
        setActiveFacilities(false);
        setActiveBedManage(false);
        break;
    }
  };

  return (
    <>
      <ToastMsg showToast={showToast} setShowToast={setShowToast} toastText={toastText} toastBody={toastBody} />

      <Container className={showMenu ? "lg div-main-menu custom-container px-5" : "lg div-main custom-container px-5"}>
        <Tab.Container defaultActiveKey={"details"}>
          <Row>
            <Col sm={toggleMenu ? 3 : 1}>
              <Nav
                variant="pills"
                className={showMenu ? "flex-column sticky-top mycase-menu-open-sticky" : "flex-column sticky-top mycase-menu-sticky"}
              >
                <Nav.Item className="mb-2">
                  {toggleMenu ? (
                    <PageTitle title={"Organization"} type={"page"} />
                  ) : (
                    <span className="hero-heading font-size-dynamic-heading fw-semibold app-header-text">{"Org"}</span>
                  )}
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="details"
                    className={activeDetails ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("details")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faBriefcase} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Details" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="household"
                    className={activeHousehold ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("household")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faUserFriends} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Household Config" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="notes"
                    className={activeNotes ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("notes")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faFileText} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Custom Notes" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="goals"
                    className={activeGoals ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("goals")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faBullseye} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Goal Templates" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="assessments"
                    className={activeAssessTypes ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("assessments")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faClipboardQuestion} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Custom Assessments" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="resources"
                    className={activeResources ? "nav-vertical-active" : "nav-vertical"}
                    onClick={() => onNavClick("resources")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <>
                      <FontAwesomeIcon icon={faBoxesStacked} className={toggleMenu ? "me-2" : "me-0"} />
                      {toggleMenu ? "Resources" : ""}
                    </>
                  </Nav.Link>
                </Nav.Item>
                {auth?.profile?.includeHMIS === 1 && (
                  <>
                    <Nav.Item className="d-grid mt-3">
                      {toggleMenu ? (
                        <PageTitle title={"Bed & Property Management"} type={"sub-section"} />
                      ) : (
                        <span className="hero-heading font-size-dynamic-heading fw-semibold app-header-text">{"Bed"}</span>
                      )}
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="dwellings"
                        className={activeDwellings ? "nav-vertical-active" : "nav-vertical"}
                        onClick={() => onNavClick("dwellings")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <>
                          <FontAwesomeIcon icon={faHouseChimney} className={toggleMenu ? "me-2" : "me-0"} />
                          {toggleMenu ? "Dwellings" : ""}
                        </>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="facilities"
                        className={activeFacilities ? "nav-vertical-active" : "nav-vertical"}
                        onClick={() => onNavClick("facilities")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <>
                          <FontAwesomeIcon icon={faBuilding} className={toggleMenu ? "me-2" : "me-0"} />
                          {toggleMenu ? "Facilities" : ""}
                        </>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="rooms"
                        className={activeBedManage ? "nav-vertical-active" : "nav-vertical"}
                        onClick={() => onNavClick("rooms")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <>
                          <FontAwesomeIcon icon={faBed} className={toggleMenu ? "me-2" : "me-0"} />
                          {toggleMenu ? "Rooms" : ""}
                        </>
                      </Nav.Link>
                    </Nav.Item>
                  </>
                )}
              </Nav>
            </Col>
            <Col xs={toggleMenu ? 9 : 11} className="mt-2">
              <Tab.Content>
                <Tab.Pane eventKey="details" className="pb-5">
                  <OrgDetails
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="household" className="pb-5">
                  <OrgHousehold
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="notes" className="pb-5">
                  <OrgCustomNoteTypes
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="goals" className="pb-5">
                  <OrgGoalTemplates
                    searchRef={searchRef}
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="assessments" className="pb-5">
                  <OrgCustomAssessments
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="resources" className="pb-5">
                  <OrgResources
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                {auth?.profile?.includeHMIS === 1 && (
                  <>
                    <Tab.Pane eventKey="dwellings">
                      <OrgDwellingManagement
                        setOrgToSave={setOrgToSave}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="facilities">
                      <OrgFacilityManagement
                        getData={facilityUpdated}
                        setOrgToSave={setOrgToSave}
                        setFacilityUpdated={setFacilityUpdated}
                        setRoomsUpdated={setRoomsUpdated}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="rooms">
                      <OrgBedManagement
                        getData={roomsUpdated}
                        setOrgToSave={setOrgToSave}
                        setFacilityUpdated={setFacilityUpdated}
                        setRoomsUpdated={setRoomsUpdated}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                  </>
                )}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </>
  );
};

export default Settings;
